import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';
import { Button } from '../../buttons/Button';
import { fontSize, fontWeight } from 'src/assets/fonts-config';

export const CmsTranslationsFormWrapper = styled('div', { label: 'CmsTranslationsFormWrapper' })`
    margin-top: 0;
    margin-bottom: 16px;
`;

export const SelectLabelWrapper = styled('div', { label: 'SelectLabelWrapper' })`
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: baseline;
`;

export const DeleteWrapper = styled('div', { label: 'DeleteWrapper' })`
    display: flex;
    align-items: center;
    gap: 4px;
    color: ${mainColors.grays.gray400};
    font-size: ${fontSize.small};
    font-weight: ${fontWeight.medium};
    cursor: pointer;
`;

export const DisplayedLanguage = styled('span', { label: 'DisplayedLanguage' })`
    font-weight: ${fontWeight.bold};
`;

interface AddTranslationButtonPropsType {
    addAnotherForm: boolean;
}

export const AddTranslationButton = styled(Button, { label: 'AddTranslationButton' })<AddTranslationButtonPropsType>`
    ${({ addAnotherForm }): string => addAnotherForm === true ? 'margin-top: 16px' : 'margin-bottom: 16px'};
`;
